import { Controller } from "@hotwired/stimulus";

const SIZE_CLASSES = ["tw-text-xl", "tw-text-lg", "tw-text-base"] as const;
const MAX_LINES = 4;

// Shrinks login marketing quotes that wrap beyond four lines (measured after layout).
export default class extends Controller {
  private resizeObserver?: ResizeObserver;

  connect() {
    this.adjust = this.adjust.bind(this);
    requestAnimationFrame(() => this.adjust());
    document.fonts?.ready.then(() => this.adjust());

    this.resizeObserver = new ResizeObserver(() => this.adjust());
    this.resizeObserver.observe(this.element);
  }

  disconnect() {
    this.resizeObserver?.disconnect();
  }

  adjust() {
    const element = this.element as HTMLElement;

    for (const sizeClass of SIZE_CLASSES) {
      element.classList.remove(...SIZE_CLASSES);
      element.classList.add(sizeClass);
      void element.offsetHeight;

      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      if (!lineHeight) {
        return;
      }

      const lines = element.scrollHeight / lineHeight;
      if (lines <= MAX_LINES) {
        return;
      }
    }
  }
}
